 const ErrorMessage =  ({message}: {message: string}) => {
    return  <div style={{color: 'red'}} className={'my-2'}>{message}</div>
}
export default ErrorMessage